
import { useState } from 'react';
import { Footer, Header, LogIn } from './components'
import AllRoutes from './routes/AllRoutes'
import TicketBar from './components/elements/TicketBar';

const App = () => {
  const [showLogin, setShowLogin] = useState(false);
  return (
    <div className="bg-custom-gradient-1 dark:bg-custom-gradient-2">
      <TicketBar />
      <Header showLogin={showLogin} setShowLogin={setShowLogin}/>
       <AllRoutes />
       <LogIn showLogin={showLogin} setShowLogin={setShowLogin} />
      <Footer/>
    </div>
  )
}

export default App